module.exports = __webpack_public_path__ + "img/chehulu2.eb961132.jpg";